import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=34c5a974&scoped=true&"
import script from "./SearchNoResults.vue?vue&type=script&lang=js&"
export * from "./SearchNoResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchNoResults.vue?vue&type=style&index=0&id=34c5a974&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5a974",
  null
  
)

export default component.exports